<app-sub-page class="width-100" navBackRoute="/about">
  <div
    class="flex width-100 column flex-1 scrollable gap-05"
    style="max-width: 800px"
    [style.height]="getContainerHeight()"
  >
    <div class="text-title width-100 flex">{{ pageTitle }}</div>
    @for (faq of faqs; track $index) {
    <div class="flex width-100 column">
      <div class="category">{{ faq.category }}</div>
      <p-accordion value="0">
        @for (faq of faq.faqs; track $index; let last = $last) {
        <p-accordionTab>
          <ng-template pTemplate="header">
            <div class="flex width-100" style="margin-right: 1rem">
              <div class="flex align-center">
                <div>{{ faq.question }}</div>
              </div>
            </div>
          </ng-template>
          <div class="flex column width-100 gap-1">
            @if (faq.answer.description) {
            <div style="font-size: 0.9rem; color: var(--text-color-secondary)">{{ faq.answer.description }}</div>
            } @if (faq.answer.paragraphs) { @for (paragraph of faq.answer.paragraphs; track $index) {
            <div class="flex column width-100">
              <div style="font-weight: 600; color: var(--text-title)">{{ paragraph.title }}</div>
              <div style="font-size: 0.9rem; color: var(--text-color-secondary)">{{ paragraph.text }}</div>
            </div>
            } }
            <div style="font-size: 0.8rem; color: var(--surface-300);">{{ faq.ref }}</div>
          </div>
        </p-accordionTab>
        @if (!last) {
        <div style="border-bottom: 1px solid var(--surface-300)"></div>
        } }
      </p-accordion>
    </div>
    }
  </div>
</app-sub-page>
